import React from "react";
import { OtcRequestItem } from "../../../otc-requests/types";

export interface OtcRatesDetailsColProps {
  request: OtcRequestItem;
  isUnderReview: boolean;
}

const isDisplayable = (val?: unknown): boolean => {
  if (val === null || val === undefined) return false;
  if (typeof val === "object") return false;
  const str = String(val).trim();
  return (
    str !== "" &&
    str !== "-" &&
    str !== "N/A" &&
    str !== "[]" &&
    str !== "{}" &&
    str !== "[object Object]" &&
    str !== "null" &&
    str !== "undefined"
  );
};

export const OtcRatesDetailsCol: React.FC<OtcRatesDetailsColProps> = ({
  request,
  isUnderReview,
}) => {
  return (
    <div className="flex flex-col border-t border-[#F2F4F7] pt-6 lg:border-l lg:border-t-0 lg:px-4 lg:pt-0">
      <div className="flex h-[40px] items-center">
        <h2 className="text-[14px] font-semibold text-[#101828]">
          {isUnderReview ? "Request details" : "Offer details"}
        </h2>
      </div>

      {/* Highlighted Row with border top AND bottom */}
      <div className="my-3.5 flex items-center justify-between border-y border-[#F2F4F7] py-3.5 text-[13px]">
        <span className="text-[#667085]">
          {isUnderReview ? "Requested rate" : "Rate offered"}
        </span>
        <span className="font-semibold text-[#101828]">
          {isUnderReview
            ? request.requestedRate || "-"
            : request.offeredRate || request.requestedRate || "-"}
        </span>
      </div>

      <div className="flex flex-col gap-4 text-[13px]">
        {/* Recipient to receive */}
        <div className="flex items-center justify-between">
          <span className="text-[#667085]">Recipient to receive</span>
          <span className="font-semibold text-[#101828]">
            {request.recipientToReceive || "-"}
          </span>
        </div>

        {/* If Offer details: Expiring in */}
        {!isUnderReview && (
          <div className="flex items-center justify-between">
            <span className="text-[#667085]">Expiring in</span>
            <span className="font-medium text-[#101828]">
              {request.expiringIn || "-"}
            </span>
          </div>
        )}

        {/* Requested rate (shown in Offer details) */}
        {!isUnderReview && (
          <div className="flex items-center justify-between">
            <span className="text-[#667085]">Requested rate</span>
            <span className="font-medium text-[#101828]">
              {request.requestedRate || "-"}
            </span>
          </div>
        )}

        {/* Initial rate / Our rate */}
        <div className="flex items-center justify-between">
          <span className="text-[#667085]">Initial rate</span>
          <span className="font-medium text-[#101828]">
            {request.ourRate || "-"}
          </span>
        </div>

        {/* Currency Pair */}
        <div className="flex items-center justify-between">
          <span className="text-[#667085]">Currency Pair</span>
          <span className="font-medium text-[#101828]">
            {request.pair || "USD - NGN"}
          </span>
        </div>

        {/* Customer Source (shown in Offer details) */}
        {isDisplayable(request.customerSource) && (
          <div className="flex items-center justify-between">
            <span className="text-[#667085]">Customer Source</span>
            <span className="font-medium text-[#101828]">
              {request.customerSource}
            </span>
          </div>
        )}

        {/* Transfer fee (in Request details) */}
        {isUnderReview && (
          <div className="flex items-center justify-between">
            <span className="text-[#667085]">Transfer fee</span>
            <span className="font-medium text-[#101828]">
              {isDisplayable(request.transferFee)
                ? request.transferFee
                : isDisplayable(request.fee)
                  ? request.fee
                  : "-"}
            </span>
          </div>
        )}

        {/* Notes */}
        <div className="flex items-start justify-between">
          <span className="text-[#667085]">Notes</span>
          <span className="max-w-[200px] text-right font-medium text-[#101828]">
            {isDisplayable(request.notes) ? request.notes : "-"}
          </span>
        </div>
      </div>
    </div>
  );
};
